import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dataItem",
  "use": "icon-dataItem-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dataItem\"><path d=\"M184.888889 1024A128 128 0 0 1 56.888889 896V128A128 128 0 0 1 184.888889 0H824.888889v128h128V1024H184.888889z m192-512H312.888889v128h64V512z m128-256H440.888889v384h64V256z m128 128H568.888889v256h64v-256z m64 320H248.888889V256H184.888889v512h512v-64z m192-512H824.888889V896H202.524444a127.488 127.488 0 0 0 110.364445 64h576v-768z\" p-id=\"28103\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol